import React, { Component } from 'react'
import isMobile from 'ismobilejs'

export const Desktop = ({children}) => !isMobile.any ? children : null;
export const Mobile = ({children}) => isMobile.any ? children : null;


// WEBPACK FOOTER //
// ./src/responsive/index.js